const IMAGES_PREFIX = 'images/all/';
export const BAR_LAYOUT_CONSTANTS = {
    IMAGES: {
        FAVICON: IMAGES_PREFIX + 'VO-favicon.ico'
    },
    GVK_KEYS: {
        MENU_STATE: 'domain.basisarch.web.core.menuState',
        PAGE_STATE: 'domain.basisarch.web.core.pageState'
    }
} as const;
